export default function Shimmer(){

    return (
        <div className="w-[80%] mx-auto mt-10 mb-20 animate-pulse">
            <div className="h-9 w-64 bg-charcoal/10 rounded mb-6"></div>
            <div className="h-16 w-full bg-charcoal/10 rounded-2xl mb-8"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {
                    Array.from({length: 8}).map((_, i) => (
                        <div key={i} className="rounded-2xl overflow-hidden border border-charcoal/10">
                            <div className="h-40 bg-charcoal/10"></div>
                            <div className="p-4 space-y-2">
                                <div className="h-5 w-3/4 bg-charcoal/10 rounded"></div>
                                <div className="h-4 w-1/2 bg-charcoal/10 rounded"></div>
                                <div className="h-4 w-2/3 bg-charcoal/10 rounded"></div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
